import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "./Header/Header";
import Creators from "./Creators/Creators";
import CoopSupport from "./CoopSupport/CoopSupport";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";
import WhatWeDo from "./WhatWeDo/WhatWeDo";
import Goals from "./Goals/Goals";
import FadeIn from "../../Components/FadeIn";

export default function MainPage() {
  return (
    <div>
      <Navbar />
      <Header />

      <FadeIn>
        <Creators />
      </FadeIn>
      <FadeIn>
        <Goals />
      </FadeIn>
      <FadeIn>
        <WhatWeDo />
      </FadeIn>

      <CoopSupport />
      <FadeIn>
        <Contact />
      </FadeIn>
      <Footer />
    </div>
  );
}
